// Shared pieces of the "download a record" flows. Kept apart from download.js so
// suites that mock the download helper keep these real (and vice versa).

export const DOWNLOAD_FAILED_MESSAGE = 'Unable to download this record. Try refreshing and downloading again.';

// How long to keep the page alive after download() hands the file to the browser.
// Chrome starts a blob download asynchronously after the link click; if the page
// reloads or navigates inside that window, the blob URL dies with the document and
// the file is silently dropped (SUP-204). In real Chrome a reload in the same tick
// lost ~1 in 15 downloads and 10ms was already enough; 500ms is margin for slow
// machines. Only callers that tear the page down afterwards need to wait.
export const BROWSER_HANDOFF_SETTLE_MS = 500;

export const waitForBrowserHandoff = (ms = BROWSER_HANDOFF_SETTLE_MS) => (
  new Promise((resolve) => { setTimeout(resolve, ms); })
);
